import axios from 'axios';

import {
  requestInterceptor,
  requestInterceptorError
} from '@/data/request/interceptors/requestInterceptor';

import {
  responseInterceptor,
  responseInterceptorError
} from '@/data/request/interceptors/responseInterceptor';

// 1) Create the Axios instance
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_KAIROS_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 3) Attach request interceptors
axiosInstance.interceptors.request.use(
  requestInterceptor,
  requestInterceptorError
);

// 4) Attach response interceptors
axiosInstance.interceptors.response.use(
  responseInterceptor,
  responseInterceptorError
);

// 5) Export the fully configured instance
export default axiosInstance;
